<template>
  <pt-branch-company-form class="pt-branch-company-form__page"  :isEdit="is_edit" :userLogin="userLogin"></pt-branch-company-form>
</template>

<script>
import PtBranchCompanyForm from 'cps/branch-company-manage/pt-branch-company/pt-branch-company-form'
export default {
  name: 'pt-branch-company-form__view',
  components: {
    'pt-branch-company-form': PtBranchCompanyForm
  },
  props: {
    isEdit: {
      type: String,
      default: ''
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
